/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Section_Dialogue_SourceInputs */



/**
* | output |
* | --- |
* | "Dialogue & Source" |
*
* @param {Ad_Section_Dialogue_SourceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_section_dialogue_source = /** @type {((inputs?: Ad_Section_Dialogue_SourceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Section_Dialogue_SourceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dialogue et source")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dialog & Quelle")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dialogo e fonte")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Диалог и Источник")
	if (locale === "es") return /** @type {LocalizedString} */ ("Diálogo y fuente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("对话与来源")
	if (locale === "ja") return /** @type {LocalizedString} */ ("対話と情報源")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संवाद और स्रोत")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Diálogo e Fonte")
	return /** @type {LocalizedString} */ ("Dialogue & Source")
});